import { render } from "./Main.vue?vue&type=template&id=405c7f39&scoped=true&ts=true"
import script from "./Main.vue?vue&type=script&lang=ts"
export * from "./Main.vue?vue&type=script&lang=ts"

import "./Main.vue?vue&type=style&index=0&id=405c7f39&scoped=true&lang=scss"

import exportComponent from "/builds/Chirbou/digithia/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-405c7f39"]])

export default __exports__